<div class="flex items-center justify-center min-h-screen py-12 px-4">
  <div class="w-full max-w-sm">
    <!-- Login Card -->
    <div class="orange-border rounded-xl py-8 px-4 sm:p-10">
      <!-- Logo Section -->
      <div class="flex items-center justify-center gap-3 mb-8">
        <img src="assets/images/sdex/headerLogo.svg" alt="Header Logo" class="h-14 w-auto drop-shadow-lg">
        <img src="assets/images/sdex/sdexLogo.svg" alt="SDEX Logo" class="h-13 w-auto drop-shadow-lg">
      </div>

      <div class="mb-10 text-center">
        <h4 class="welcome-text font-semibold text-orange">{{ welcomeText }}</h4>
      </div>

      <!-- Sign Up Buttons -->
      <div class="space-y-3">
        <button 
          (click)="signUp('google')"
          class="w-full px-1 py-2 bg-white orange-border rounded-xl font-medium text-gray-900 transition-all duration-300 flex items-center justify-center gap-2 group">
          <ng-container *ngIf="!googleLoading else googleLoader">
          <img src="assets/images/login/google.png" alt="Google Icon" class="h-7 w-7 group-hover:scale-110 transition-transform">
          <span class="text-orange">Sign In with Google</span>
          </ng-container>
          <ng-template #googleLoader>
            <fa-icon [icon]="faSpinner"  class="text-orange" [animation]="'spin'"></fa-icon>
          </ng-template>
        </button>

        <!-- <button 
          (click)="signUp('microsoft')"
          class="w-full px-1 py-2 bg-white orange-border rounded-xl font-medium text-gray-900 transition-all duration-300 flex items-center justify-center gap-2 group">
          <ng-container *ngIf="!microsoftLoading else microsoftLoader">
          <img src="assets/images/login/microsoft.png" alt="Microsoft Icon" class="h-7 w-7 group-hover:scale-110 transition-transform">
          <span class="text-orange">Sign In with Microsoft</span>
          </ng-container>

          <ng-template #microsoftLoader>
            <fa-icon [icon]="faSpinner" class="text-orange" [animation]="'spin'"></fa-icon>
          </ng-template>
        </button> -->
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMsg"
        class="mt-2 px-4 py-3 rounded-xl bg-red-50 border border-red-200 text-red-600 text-sm font-medium flex items-center gap-3 shadow-sm">
        <span>{{ errorMsg }}</span>
      </div>

    </div>
  </div>
</div>
